import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

//---helpers
import { PRODUCTS_ORDER_KEY } from '@/helpers';
import { globalLoader, pluralizate } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import ProductsBlock from '@/components/products/ProductsBlock/index.vue';
import Pagination from '@/components/@general/Pagination/index.vue';
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'CatalogTag',
  mixins: [dynamicHead],
  components: {
    BreadcrumbsSimple,
    ProductsBlock,
    Pagination
  },
  data() {
    return {
      PRODUCTS_ORDER_KEY,
      catalogPromoData: null,
      catalogPromoProducts: [],
      catalogPromoMeta: null,
      isCatalogPromoLoading: false
    };
  },
  created() {
    this._loadContent();
  },
  watch: {
    $route: {
      immediate: false,
      handler(newVal) {
        if (newVal) {
          this._getProducts();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList'
    }),
    titlePluralizate() {
      return pluralizate(
        this.catalogPromoMeta ? this.catalogPromoMeta.total : 0,
        this.$t('label.products.countOne'),
        this.$t('label.products.countSimple'),
        this.$t('label.products.countMany')
      );
    },
    productsList() {
      if (!this.isAuthenticated || !this.favourites) {
        return this.catalogPromoProducts;
      }

      const favourites = _.map(this.favourites, 'productId');
      const markAsSelected = (product) => {
        product.isFavorite = favourites.includes(product.id);
        return product;
      };

      return _.map(this.catalogPromoProducts, markAsSelected);
    }
  },
  methods: {
    ...mapActions({
      getCatalogProducts: 'catalog/GET_CATALOG_PRODUCTS',
      getPromo: 'sales/GET_PROMOTION',
      getPage: 'staticPages/GET_PAGE'
    }),
    _getProducts() {
      this.isCatalogPromoLoading = true;
      let { params: routeParams, query } = this.$route;
      let { page, id } = routeParams;
      let { orderby } = query;

      return this.getCatalogProducts({
        sale_banners: id,
        page: page ? Number(page) : 1,
        sort_filter_type: orderby ? orderby : PRODUCTS_ORDER_KEY.BESTSELLERS
      })
        .then((result) => {
          this.catalogPromoProducts = result.data;
          this.catalogPromoMeta = result.meta;
        })
        .finally(() => {
          this.isCatalogPromoLoading = false;
        });
    },
    async _loadContent() {
      globalLoader(true);
      let promiseCollection = [];
      let { id } = this.$route.params;
      promiseCollection.push(
        this.getPromo(id).then((data) => {
          this.catalogPromoData = data;
          this._setMetaParams();
        })
      );
      promiseCollection.push(this._getProducts());
      await Promise.all(promiseCollection);

      globalLoader(false);
    },

    _setMetaParams() {
      let { title, description, image } = this.catalogPromoData;
      title = title ?? this.$t('page.promo.title');
      this.metaParams.title = `${title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = description || `${title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    }
  }
};
